'use strict';

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.is-array');

require('core-js/modules/es6.array.for-each');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.map');

require('core-js/modules/es6.promise');

require('linksoft-albatros/src/plugins/dropdown');

require('./app/main');

require('./app/modules/min-max-setting');

require('./app/modules/offlineBox');

require('./app/watchdog');

require('./app/user');

require('./app/editor');

require('./app/comissionStockDt');

require('./app/stateAtLocationFilterByOzUser');

require('./app/dt-control-buttons');

var _tableTemplates = require('./app/table-templates');

var _tableTemplates2 = _interopRequireDefault(_tableTemplates);

var _initializers = require('./app/initializers');

var _initializers2 = _interopRequireDefault(_initializers);

var _store = require('./app/store');

var _store2 = _interopRequireDefault(_store);

var _store3 = require('linksoft/core/store');

var _store4 = _interopRequireDefault(_store3);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./app/menu');

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _localize = require('linksoft/core/localize');

var _urls = require('./app/urls');

require('./app/components');

var _reducers = require('linksoft/core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _reducer = require('./app/cart/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('./app/facets/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

require('linksoft/initializers/cookie-value');

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// register reducers before creating store


//import ls from 'linksoft';
// This is entry point for building single output 'main.js' (except vendor libs defined in 'Gulp/vendors.js')

// polyfills
var log = require('debug')('app:startup');

// Load all React.js components/containers


_reducers2.default.add('cart', _reducer2.default);
_reducers2.default.add('facets', _reducer4.default);

// register all required initializers
_initialize2.default.registerAll(_initializers2.default);
_initialize2.default.register(_linksoftReact2.default.finalizer, true);

(0, _jquery2.default)(document).on('loaded.bs.modal', function (e) {
    log('modal content loaded %o', e.target);
    _initialize2.default.trigger(e.target);
});

// trigger first initialization.
(0, _jquery2.default)(function () {
    // create app state store
    _store4.default.set((0, _store2.default)());
    _linksoftAlbatros.settings.initFromHiddenField('settings');

    (0, _tableTemplates2.default)();

    (0, _localize.loadLocale)().then(function () {
        (0, _urls.initUrls)();
        _initialize2.default.trigger();
    });

    (0, _jquery2.default)(document).on('click', '#show-filters-mobile', function () {
        (0, _jquery2.default)(this).next().toggleClass('open').slideToggle();

        if ((0, _jquery2.default)(this).next().hasClass('open')) {
            (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-close'));
        } else {
            (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-open'));
        }
    });

    // for menu in mobile
    (0, _jquery2.default)(document).on('click', '.navbar-toggle', function () {
        (0, _jquery2.default)(this).toggleClass('open');
        (0, _jquery2.default)('.navbar-collapse').toggleClass('open');
    });

    // hash for tab switching
    function tabHashSwitching() {
        var hash = window.location.hash;
        (0, _jquery2.default)('[data-nav-tab] a[href="' + hash + '"]').tab('show');

        (0, _jquery2.default)('[data-nav-tab] a').on('click', function (e) {
            e.preventDefault();
            history.pushState(null, null, this.hash);
        });
    }

    // after all js is loaded we switch tab for load new datatable
    window.addEventListener('DOMContentLoaded', function () {
        window.setTimeout(function () {
            tabHashSwitching();
            window.addEventListener('hashchange', tabHashSwitching, false); // track changing of the hash and this display the selected tab
        }, 800);
    });

    // in order to avoid displaying the outdated page in case if used has used 
    // back button for navigating back, force page reload
    window.addEventListener('pageshow', function () {
        var _performance$getEntri = performance.getEntriesByType("navigation"),
            _performance$getEntri2 = (0, _slicedToArray3.default)(_performance$getEntri, 1),
            entry = _performance$getEntri2[0];

        if (entry["type"] === "back_forward") {
            location.reload();
        }
    });

    if (typeof faqs !== 'undefined') {
        _jquery2.default.each(faqs, function (i, v) {
            var $wrap = (0, _jquery2.default)('#faq');

            $wrap.append('<li><a href="#faq-' + i + '">' + v.groupTitle + '</a><ul id="faq-' + i + '" class="faq__sub"></ul></li>');

            _jquery2.default.each(v.groupSubItems, function (y, d) {
                (0, _jquery2.default)('#faq-' + i).append('<li><a class="show-answer" id="faq-sub-' + i + y + '" href="#">' + d.groupSubItemQuestion + '</a></li>');
                (0, _jquery2.default)('#faq-sub-' + i + y + '').data('answer', d.groupSubItemAnwser);
            });
        });

        (0, _jquery2.default)('.faq > li > a, .faq__sub > li > a').on('click', function (e) {
            e.preventDefault();
            var $this = (0, _jquery2.default)(this);

            (0, _jquery2.default)('.faq__sub > li').removeClass('active');
            (0, _jquery2.default)('.faq__sub > li > a').next().removeClass('active');
            (0, _jquery2.default)('#faq-answer').empty();

            $this.parent().toggleClass('active');
            $this.next().toggleClass('active');
        });

        (0, _jquery2.default)('.show-answer').on('click', function (e) {
            e.preventDefault();
            var text = (0, _jquery2.default)(this).data('answer');

            (0, _jquery2.default)('#faq-answer').removeClass('hide');

            (0, _jquery2.default)('#faq-answer').html(text);
        });
    }

    // close invoice popup
    (0, _jquery2.default)(document).on('click', '.tips-text .icon-delete', function () {
        (0, _jquery2.default)(this).closest('.info-dept').removeClass('open');
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app.js
// module id = 0
// module chunks = 0